// import React from "react";

// const WhyChooseUs = () => {
//   const features = [
//     {
//       icon: "/images/w-choose-icon/icon-1.png",
//       title: "Affordable & Transparent Fares",
//       description:
//         "Enjoy competitive and transparent fares for Pune city rides, outstation trips, airport transfers and Pune to Mumbai travel.",
//     },
//     {
//       icon: "/images/w-choose-icon/icon-2.png",
//       title: "Reliable Pune Outstation Service",
//       description:
//         "Travel comfortably with Garud Cab Service for one-way and round-trip outstation journeys from Pune to destinations across Maharashtra.",
//     },
//     {
//       icon: "/images/w-choose-icon/icon-3.png",
//       title: "Comfortable & Well-Maintained Cabs",
//       description:
//         "Choose from comfortable vehicles including Maruti Ertiga, Toyota Rumion, Kia Carens, Innova Cab and Innova Crysta.",
//     },
//     {
//       icon: "/images/w-choose-icon/icon-4.png",
//       title: "Experienced Drivers",
//       description:
//         "Our experienced and professional drivers focus on safe, punctual and comfortable travel for every journey.",
//     },
//   ];

//   return (
//     <div
//       className="section-full site-bg-white twm-w-chooseus-section-wrap wow fadeInDown"
//       data-wow-offset="100"
//       data-wow-delay="0.2s"
//     >
//       <div className="container">
//         <div className="row twm-w-chooseus-section">

//           {/* Left Content */}
//           <div className="col-lg-5 col-md-12">

//             {/* TITLE START */}
//             <div className="section-head left">
//               <div className="twm-sm-title left">
//                 Why Garud Cab?
//               </div>

//               <h2 className="twm-large-title site-text-dark">
//                 Why Choose Garud Cab Service?
//               </h2>

//               <div className="section-head-detail">
//                 Garud Cab Service is your trusted travel partner in Pune,
//                 offering reliable, comfortable and affordable cab services
//                 for local travel, airport transfers, Pune outstation trips
//                 and Pune to Mumbai journeys.
//               </div>
//             </div>
//             {/* TITLE END */}

//             {/* Features List */}
//             <div className="twm-list-icon-style1">
//               <ul>
//                 {features.map((feature, index) => (
//                   <li key={index}>
//                     <div className="twm-list-icon-style-bx">

//                       {/* Icon */}
//                       <div className="twm-icon-bx">
//                         <span>
//                           <img
//                             src={feature.icon}
//                             alt={feature.title}
//                           />
//                         </span>
//                       </div>

//                       {/* Content */}
//                       <div className="twm-icon-bx-detail">
//                         <h3 className="twm-title">
//                           {feature.title}
//                         </h3>

//                         <p>{feature.description}</p>
//                       </div>

//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>

//           {/* Right Content */}
//           <div className="col-lg-7 col-md-12">
//             <div className="twm-w-chooseus-media">

//               {/* Main Image */}
//               <div className="twm-media">
//                 <img
//                   src="/images/need-h-pic.png"
//                   alt="Garud Cab Service Pune"
//                 />
//               </div>

//               {/* Help Box */}
//               <div className="twm-need-help-bx">

//                 <div className="twm-need-help-content">
//                   <span>Need a cab or any help?</span>

//                   <h3 className="twm-title">
//                     +91 9970007784
//                   </h3>
//                 </div>

//                 <div className="twm-need-help-icon">
//                   <img
//                     src="/images/24-clock.png"
//                     alt="24 Hour Cab Support"
//                   />
//                 </div>

//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhyChooseUs;



import React from "react";

const WhyChooseUs = () => {
  const features = [
    {
      icon: "/images/w-choose-icon/icon-1.png",
      title: "Affordable Fares",
      description: "Comfortable cabs at competitive and transparent prices.",
    },
    {
      icon: "/images/w-choose-icon/icon-2.png",
      title: "Outstation Cabs",
      description: "Reliable one-way and round-trip outstation services.",
    },
    {
      icon: "/images/w-choose-icon/icon-3.png",
      title: "Comfortable Vehicles",
      description: "Clean and well-maintained cars for a smooth journey.",
    },
    {
      icon: "/images/w-choose-icon/icon-4.png",
      title: "Professional Drivers",
      description: "Experienced drivers for safe and comfortable travel.",
    },
  ];

  return (
    <div
      className="section-full site-bg-white twm-w-chooseus-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2s"
    >
      <div className="container">
        <div className="row twm-w-chooseus-section">

          {/* Left Content */}
          <div className="col-lg-5 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">
                Why Garud Cab?
              </div>

              <h2 className="twm-large-title site-text-dark">
                Why Choose Us?
              </h2>

              <div className="section-head-detail">
                Reliable, affordable and comfortable cab services in Pune
                and for outstation travel.
              </div>
            </div>

            {/* Features */}
            <div className="twm-list-icon-style1">
              <ul>
                {features.map((feature, index) => (
                  <li key={index}>
                    <div className="twm-list-icon-style-bx">

                      <div className="twm-icon-bx">
                        <span>
                          <img
                            src={feature.icon}
                            alt={feature.title}
                          />
                        </span>
                      </div>

                      <div className="twm-icon-bx-detail">
                        <h3 className="twm-title">
                          {feature.title}
                        </h3>

                        <p className="text-dark fw-bold">
                          {feature.description}
                        </p>
                      </div>

                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-7 col-md-12">
            <div className="twm-w-chooseus-media">

              <div className="twm-media">
                <img
                  src="/images/car-pic1.png"
                  alt="Garud Cab Service"
                />
              </div>

              {/* Help Box */}
              <div className="twm-need-help-bx">
                <div className="twm-need-help-content">
                  <span>Need a Cab?</span>

                  <h3 className="twm-title">
                    +91 9970007784
                  </h3>
                </div>

                {/* <div className="twm-need-help-icon">
                  <img
                    src="/images/24-clock.png"
                    alt="24 Hour Support"
                  />
                </div> */}
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
